/** After /einloggen, send admins and employees to their dashboards unless a specific next URL was requested. */
export const resolvePostLoginPath = (user, nextParam) => {
  const next = String(nextParam || "").trim() || "/konto";
  if (user?.isAdmin) {
    if (next === "/konto" || next === "/einloggen") return "/admin-dashboard";
    return next;
  }
  if (user?.isEmployee) {
    if (next === "/konto" || next === "/einloggen") return "/mitarbeiter";
    return next;
  }
  return next;
};
